<template>
  <div class="star-rating">
    <span v-for="(star, index) in stars" :key="index">
      <svg
          class="star-rating-star"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          :width="`${size}px`"
          :height="`${size}px`"
          viewBox="60 -62 309 309"
      >
        <polygon
            data-side="center"
            class="star-rating-star-wrap"
            points="281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 212.9,181.1 213.9,181 306.5,241"
        />
        <polygon
            data-side="left"
            class="star-rating-star-left"
            :class="{filled: star.leftFilled}"
            points="281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 213.9,181.1 213.9,181 306.5,241"
        />
        <polygon
            data-side="right"
            class="star-rating-star-right"
            :class="{filled: star.rightFilled}"
            points="364,55.7 255.5,46.8 214,-59 213.9,181 306.5,241 281.1,129.8"
        />
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  props: {
    rating: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      default: 24
    }
  },
  computed: {
    stars() {
      let stars = [];
      let i = 0;
      while (i < 10) {
        stars.push({
          leftFilled: this.rating - 1 >= i,
          rightFilled: this.rating - 1 >= i + 1
        });
        i = i+2;
      }

      return stars;
    }
  }
}
</script>
